import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { Password, AccountProfile } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
    height:'100vh'
  }
}));

const Settings = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
        {/* <Grid
          item
          md={4}
          xs={12}
        >
          <AccountProfile />
          
        </Grid> */}
        <Grid
          item
          md={4}
          xs={12}
        >
         <Password />
        </Grid>
      </Grid>
    </div>
  );
};

export default Settings;
